import { makeAutoObservable, runInAction } from 'mobx';
import {
  ApproveDiscound,
  attachmentRemoveParam,
  ContractReport,
  IAttachment,
  IContractGetHistoryParam,
  IContractInfo,
  IContractInfoDetails,
  IContractInfoParams,
  IContractInfoReport,
  IContractReportParam,
} from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { ShopReportData } from 'src/@types/Choqorak/MainTables/Shop/Shop';
import agent from 'src/api/agent';
export default class ContractInfoStore {
  openDialog = false;

  openAttachmentDialog = false;

  ApproveDiscountDialog = false;

  AttanchmentDialog = false;

  AdvancePayDialog = false;

  RentAdvancePaymentDialog = false;

  ApprovedAndLock = false;

  ContractExtentDialog = false;

  ContractInfoRegistry = new Map<number, IContractInfo>();

  editMode = false; //When click on edit button

  selectedContractInfo: IContractInfo | undefined = undefined;

  totalRecord: number = 0;

  selectedContractInfoDetail: IContractInfoDetails | undefined;

  ContractReportResult: ContractReport | undefined;

  ContractHistoryResult: IContractInfo[] | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get ContractInfoList() {
    return Array.from(this.ContractInfoRegistry.values());
  }

  setContractInfoList = (ContractInfo: IContractInfo) => {
    this.ContractInfoRegistry.set(ContractInfo.contractId!, ContractInfo);
  };

  snackbar = async (soundType: string) => {
    let audio;
    if (soundType === 'rejectSound') {
      audio = new Audio(require('src/assets/notification/reject.mp3'));
    } else {
      audio = new Audio(require('src/assets/notification/notification.mp3'));
    }

    await audio.play();
  };

  //Pagination
  loadContractInfo = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadUnapprovedList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      // if (signalName !== undefined) {
      //   this.ContractInfoRegistry.clear();
      // }
      const result = await agent.ContractInfo.unapprovedList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadApprovedList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.approvedList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadExpiredList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.expiredList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed
          .filter((lst: any) => lst.contractStatusId === 6)
          .forEach((lst: any) => {
            this.setContractInfoList(lst);
          });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadAbouttoexpireList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.abouttoexpireList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadTerminatedList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.terminatedList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Pagination
  loadActiveContractList = async (params: IContractInfoParams, reset: boolean = false) => {
    if (!reset) {
      this.ContractInfoRegistry.clear();
    }
    try {
      const result = await agent.ContractInfo.activeContractList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setContractInfoList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ContractInfoSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadContractInfo(params);
  };

  ContractInfoNeedApprovalSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadUnapprovedList(params);
  };

  ContractInfoAbouttoExpireSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadAbouttoexpireList(params);
  };

  ContractInfoExpireSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadExpiredList(params);
  };

  ContractInfoTerminatSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadTerminatedList(params);
  };


  ContractInfoApproveSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadApprovedList(params);
  };

  ContractInfoActiveSearch = async (params: IContractInfoParams) => {
    this.ContractInfoRegistry.clear();
    this.loadActiveContractList(params);
  };

  getContractInfoFromRegistry = (id: number) => {
    let ContractInfo = this.ContractInfoRegistry.get(id);
    if (ContractInfo) {
      this.editMode = true;
      this.selectedContractInfo = ContractInfo;
    }
  };

  clearSelectedContractInfo = () => {
    this.editMode = false;
    this.selectedContractInfo = undefined;
    this.selectedContractInfoDetail = undefined;
  };

  deleteContractInfo = async (id: number, remark?: string) => {
    await agent.ContractInfo.delete(id, remark!);
    runInAction(() => {
      this.ContractInfoRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  deleteContractInfoAttachment = async (id: number, ContractId: number) => {
    await agent.ContractInfo.deleteAttachment(id);
    runInAction(() => {
      this.loadContractInfoDetail(ContractId);
      this.setOpenCloseAttachmentDialogBox();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  setOpenCloseAttachmentDialogBox = () => (this.openAttachmentDialog = !this.openAttachmentDialog);

  setOpenCloseApproveDiscountDialog = () =>
    (this.ApproveDiscountDialog = !this.ApproveDiscountDialog);

  setOpenCloseAttachmentDialog = () => (this.AttanchmentDialog = !this.AttanchmentDialog);

  setOpenCloseAdvancePayDialogDialog = () => (this.AdvancePayDialog = !this.AdvancePayDialog);

  setOpenCloseApprovedAndLockDialog = () => (this.ApprovedAndLock = !this.ApprovedAndLock);

  setOpenCloseRentAdvancePaymentDialog = () =>
    (this.RentAdvancePaymentDialog = !this.RentAdvancePaymentDialog);

  setOpenCloseExtendDialog = () => (this.ContractExtentDialog = !this.ContractExtentDialog);

  createContractInfo = async (ContractInfo: IContractInfo) => {
    await agent.ContractInfo.create(ContractInfo);
    runInAction(() => {

      this.clearSelectedContractInfo();
    });
  };

  updateContractInfo = async (ContractInfo: IContractInfo) => {
   
    await agent.ContractInfo.update(ContractInfo);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });
      this.ContractInfoRegistry.delete(ContractInfo.contractId!);
      this.ContractInfoRegistry.set(ContractInfo.contractId!, ContractInfo);
      this.clearSelectedContractInfo();
    });
  };

  ApproveDiscount = async (ApproveDiscound: ApproveDiscound) => {
    await agent.ContractInfo.ApproveDiscount(ApproveDiscound, ApproveDiscound.attachment);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  Attachment = async (attachment: IAttachment) => {
    await agent.ContractInfo.Attachment(attachment, attachment.attachment);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  RecievedAdvance = async (IContractInfo: IContractInfo) => {
    await agent.ContractInfo.RecievedAdvancePay(IContractInfo, IContractInfo.attachment);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  ContractLock = async (IContractInfo: IContractInfo) => {
    await agent.ContractInfo.ContracLock(IContractInfo, IContractInfo.attachment);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  ContractTerminate = async (IContractInfo: IContractInfo) => {
    await agent.ContractInfo.ContractTerminate(IContractInfo);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  ExpirationSettlement = async (IContractInfo: IContractInfo) => {
    await agent.ContractInfo.ExpirationSettlement(IContractInfo);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  ContractExtend = async (IContractInfo: IContractInfo) => {
    await agent.ContractInfo.ContractExtend(IContractInfo, IContractInfo.attachment);

    runInAction(() => {
      this.loadContractInfo({ pageIndex: 0, pageSize: 5 });

      this.clearSelectedContractInfo();
    });
  };

  loadContractInfoDetail = async (id: number) => {
    try {
      const getContractInfoDetail = await agent.ContractInfo.getDetail(id);
      runInAction(() => {
        this.editMode = true;
        this.selectedContractInfoDetail = getContractInfoDetail;
      });
    } catch (error) { }
  };

  loadContractReport = async (reportParams: IContractReportParam) => {
    const axiosResponse = await agent.ContractInfo.getContractReport(reportParams);

    runInAction(() => {
      this.ContractReportResult = axiosResponse.data;
    });
  };

  GetHistory = async (reportParams: IContractGetHistoryParam) => {
    const axiosResponse = await agent.ContractInfo.GetContractHistoryList(reportParams);

    runInAction(() => {
      this.ContractHistoryResult = axiosResponse.data;
    });
  };
}
